export default __webpack_public_path__ + "static/media/RightAnswerWin.56b972d8.wav";